// extracted by mini-css-extract-plugin
export var closeButton = "_l7-1";
export var closeX = "_l7-3";
export var container = "_l7-0";
export var image = "_l7-2";